"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _WindowAPI = _interopRequireDefault(require("../entel/WindowAPI"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class WindowAPICl extends _WindowAPI.default {
  constructor(props) {
    super(props);
  }
}
var _default = WindowAPICl; // Example usage
// guidedSelling.handsetFlowChile.BrandFlow({"brand":"Apple"});
exports.default = _default;